import { Component, OnInit, ViewChild } from '@angular/core';
import { isBs3 } from 'ngx-bootstrap/utils';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ModalDirective } from 'ngx-bootstrap/modal';
// import { Module } from 'ag-grid-community';
import { Module, AllCommunityModules } from '@ag-grid-community/all-modules';
import { ConstantService } from '../../../services/constant.service';
import { Router } from '@angular/router';
import { ViewRendererComponent } from '../../../renderer/view-renderer.component';
import { ApiService } from '../../../services/api.service';
import { GrievanceService } from '../../../services/grievance.services';
import { EditButtonRendererComponent } from '../../../renderer/edit-button-renderer.component';
import { DeleteButtonRendererComponent } from '../../../renderer/delete-button-renderer.component';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import { ExcelService } from '../../../services/export-excel.service';
import { ImageRendererComponent } from '../../../renderer/image-renderer.component';

@Component({
  selector: 'app-day-attendance',
  templateUrl: './day-attendance.component.html'
})
export class DayAttendanceComponent implements OnInit {
  @ViewChild('deleteComplainModal') public deleteComplainModal: ModalDirective;
  @ViewChild('deleteBulkComplainModal') public deleteBulkComplainModal: ModalDirective;
  @ViewChild('updateComplaintModal') public updateComplaintModal: ModalDirective;
  @ViewChild('attachmentModal') public attachmentModal: ModalDirective;
  @ViewChild('inAttendModal') public inAttendModal: ModalDirective;
  @ViewChild('outAttendModal') public outAttendModal: ModalDirective;
  isBs3 = isBs3();
  public gridApi;
  public gridColumnApi;
  public gridOptions;
  public modules: Module[] = AllCommunityModules;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public columnDefs;
  public permission;
  public rowClassRules;
  public rowSelection;
  _ = _;

  dropdownList = [];
  punchSlotList = [];
  selectedPunchSlot = [];
  selectedUser = [];
  dropdownSettings: IDropdownSettings = {
    "singleSelection": true,
    "allowSearchFilter": true,
    "closeDropDownOnSelection": true,
    "enableCheckAll": false,
    "limitSelection": 1
  };
  filterParams = {
    dateRange: [new Date(), new Date()],
    date: new Date(),
    project: '',
    username: '',
    attendance: 'all'
  }
  attendanceList: any = [];

  bsRangeValue: Date[];
  paginaton = {
    totalItems: 0,
    currentPage: 1,
    maxSize: 100,
  }

  attendForm: any = {
    in_time: moment().format('YYYY-MM-DDTHH:mm'),
    out_time: moment().format('YYYY-MM-DDTHH:mm'),
    in_remarks: '',
    out_remarks: '',
    modified_by: ''
  }

  alert = {
    type: 'info',
    msg: '',
    timeout: 3000
  }
  maxDate = new Date();

  exportAsConfig: ExportAsConfig = {
    type: 'pdf', // the type you want to download
    elementIdOrContent: 'tableToPrint', // the id of html/table element,
    options: { // html-docx-js document options

      jsPDF: {
        orientation: 'landscape',
      },
      margins: {
        top: '40px',
        bottom: '40px',
        left: '40px',
        right: '40px'
      }

    }
  }

  username = '';
  selectedComplaint: any = {};

  exportingCsv = false;
  constructor(private constantService: ConstantService, private apiService: ApiService, private grievanceService: GrievanceService,
    public router: Router, private exportAsService: ExportAsService, private excelService: ExcelService) {
    this.permission = this.constantService.getCookies().PERMISSION;
    let permissionArray = this.permission.split('');
    this.username = this.constantService.getCookies().USERNAME;

    this.context = { componentParent: this };
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      filterParams: {
        buttons: ['clear'],
        flex: 1,
      }
    };

    this.frameworkComponents = {
      viewRenderer: ViewRendererComponent,
      editButtonRenderer: EditButtonRendererComponent,
      deleteButtonRenderer: DeleteButtonRendererComponent,
      imageButtonRenderer: ImageRendererComponent,
    };

    this.rowSelection = 'multiple';

    this.columnDefs = [
      { headerName: 'Date', field: 'date', width: 120 },
      { headerName: 'Project', field: 'project_name', width: 150 },
      { headerName: 'Employee Id', field: 'employee_id', width: 100 },
      { headerName: 'User Id', field: 'username', width: 150 },
      { headerName: 'User Name', field: 'fullName', width: 150 },
      { headerName: 'Location', field: 'location', width: 150 },
      {
        headerName: 'In Detail',
        children: [
          {
            headerName: 'In Time', field: 'in_time', width: 120, columnGroupShow: 'closed',
            cellRenderer: params => { return params.data.in_time && params.data.in_time !== '0000-00-00 00:00:00' ? moment(params.data.in_time).format('HH:mm') : '' }
          },
          { headerName: 'Address', field: 'in_location', width: 150, columnGroupShow: 'closed' },
          { headerName: 'Remarks', field: 'in_remarks', width: 150, columnGroupShow: 'closed' },
          { headerName: 'Latitude', field: 'in_latitude', flex: 1, columnGroupShow: 'open' },
          { headerName: 'Longitude', field: 'in_longitude', flex: 1, columnGroupShow: 'open' },
          {
            headerName: 'Attachment', field: 'value',
            cellRenderer: params => { return params.data.in_attachment ? '<img src="' + params.data.in_attachment + '" width="100px" height="100px">' : '' },
            colId: 'in_attachment', width: 150, filter: false, resizable: true, sortable: false, cellClass: ['text-center'], columnGroupShow: 'closed'
          },

        ]
      },
      {
        headerName: 'Out Detail',
        children: [
          {
            headerName: 'Out Time', field: 'out_time', width: 120, columnGroupShow: 'closed',
            cellRenderer: params => { return (params.data.out_time && params.data.out_time !== '0000-00-00 00:00:00') ? moment(params.data.out_time).format('HH:mm') : '' }
          },
          { headerName: 'Address', field: 'out_location', width: 150, columnGroupShow: 'closed' },
          { headerName: 'Remarks', field: 'out_remarks', width: 150, columnGroupShow: 'closed' },
          { headerName: 'Latitude', field: 'out_latitude', flex: 1, columnGroupShow: 'open' },
          { headerName: 'Longitude', field: 'out_longitude', flex: 1, columnGroupShow: 'open' },
          {
            headerName: 'Attachment', field: 'value',
            cellRenderer: params => { return params.data.out_attachment ? '<img src="' + params.data.out_attachment + '" width="100px" height="100px">' : '' },
            colId: 'out_attachment', width: 150, filter: false, resizable: true, sortable: false, cellClass: ['text-center'], columnGroupShow: 'closed'
          },

        ]
      },
      {
        headerName: 'Status', field: 'status', width: 60, filter: false, pinned: 'right', cellRenderer: params => {
          return `<div class="${params.data.status}" ></div>`;
        }
      },
    ]

    if (_.includes(permissionArray, 'd')) {
      this.columnDefs.push({
        headerName: 'In', field: 'value', cellRenderer: params => { return `<i class="fa fa-2x fa-sign-in pointer"></i>` }
        , colId: 'in_attend', width: 60, filter: false, resizable: true, sortable: false, pinned: 'right', cellClass: ['text-center']
      }),
        this.columnDefs.push({ headerName: 'Out', field: 'value', cellRenderer: params => { return `<i class="fa fa-2x fa-sign-out pointer"></i>` }, colId: 'out_attend', width: 60, filter: false, resizable: true, sortable: false, pinned: 'right', cellClass: ['text-center'] },
          //  { headerName: 'Delete', field: 'value', cellRenderer: 'deleteButtonRenderer', colId: 'params1',  width: 60, filter: false, resizable: true, sortable: false, pinned: 'right',cellClass: ['text-center']  },
        )
    }

  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    console.log(this.grievanceService.getSelectedDateRange());
    if (this.grievanceService.getSelectedDateRange().length > 0) {
      this.filterParams.dateRange = this.grievanceService.getSelectedDateRange();
    }

    this.getResources();

  }
  records = [];
  paginatedRecord = [];
  searchReport() {
    this.records = [];
    this.paginatedRecord = [];
    this.attendanceList = [];
    let queryString = "attendance.*, project.name as project_name FROM attendance, project WHERE DATE(attendance.date) = '" + moment(this.filterParams.date).format('YYYY-MM-DD') + "'";
    if (this.filterParams.username) queryString += " AND attendance.username LIKE '" + this.filterParams.username + "'";
    if (this.filterParams.project) queryString += " AND attendance.project LIKE '" + this.filterParams.project + "'";
    queryString += " AND attendance.project = project.srl_no ORDER BY srl_no DESC";
    console.log(queryString);
    this.apiService.getCustomData(btoa(queryString)).subscribe((resp: any) => {
      this.records = resp;
      let records = {};
      _.each(this.records, (i) => {
        records[i.username] = i;
      })

      _.each(this.userList, (user) => {
        let userAttendance = {
          employee_id: user.employee_id,
          fullName: user.full_name,
          username: user.phone_no,
          location: user.work_location,
          project_name: this.projectObject[user.project] ? this.projectObject[user.project].name : '',
          project: user.project,
          date: moment(this.filterParams.date).format('YYYY-MM-DD'),
          srl_no: records[user.phone_no] ? records[user.phone_no].srl_no : '',
          in_time: records[user.phone_no] ? records[user.phone_no].in_time : '',
          in_latitude: records[user.phone_no] ? records[user.phone_no].in_latitude : '',
          in_longitude: records[user.phone_no] ? records[user.phone_no].in_longitude : '',
          in_location: records[user.phone_no] ? records[user.phone_no].in_address : '',
          in_attachment: records[user.phone_no] ? records[user.phone_no].in_attachment : '',
          out_time: records[user.phone_no] ? records[user.phone_no].out_time : '',
          out_latitude: records[user.phone_no] ? records[user.phone_no].out_latitude : '',
          out_longitude: records[user.phone_no] ? records[user.phone_no].out_longitude : '',
          out_location: records[user.phone_no] ? records[user.phone_no].out_address : '',
          out_attachment: records[user.phone_no] ? records[user.phone_no].out_attachment : '',
          status: records[user.phone_no] ? 'present' : 'absent',
          in_remarks: records[user.phone_no] ? records[user.phone_no].in_remarks : '',
          out_remarks: records[user.phone_no] ? records[user.phone_no].out_remarks : '',
          modified_by: records[user.phone_no] ? records[user.phone_no].modified_by : '',
        }

        if (this.filterParams.attendance === 'all') {
          this.attendanceList.push(userAttendance);
        } else if (this.filterParams.attendance === 'absent') {
          if (!records[user.phone_no]) this.attendanceList.push(userAttendance);
        } else if (this.filterParams.attendance === 'present') {
          if (records[user.phone_no]) this.attendanceList.push(userAttendance);
        }

      });
      console.log(this.attendanceList);
      console.log(_.keys(this.attendanceList[0]))
      this.paginatedRecord = this.attendanceList;
      this.arrangeDataForExport(this.paginatedRecord);
    })
  }

  pageChanged(event): void {
    this.paginaton.currentPage = event.page;
    this.paginatedRecord = this.records.slice((this.paginaton.currentPage - 1) * this.paginaton.maxSize, this.paginaton.currentPage * this.paginaton.maxSize);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  selectedColumnId = '';
  onCellClicked(params) {
    console.log(params)
    this.selectedColumnId = params.column.colId;

    this.selectedData = params.data;
    if (this.selectedColumnId === 'in_attachment' || this.selectedColumnId === 'out_attachment') {
      this.attachmentModal.show();
    }
    if (this.selectedColumnId === 'in_attend') {
      this.attendForm.in_time = moment(this.selectedData.in_time).format('YYYY-MM-DDTHH:mm');
      this.attendForm.in_remarks = this.selectedData.in_remarks ? this.selectedData.in_remarks : '';
      this.attendForm.modified_by = this.username;
      this.inAttendModal.show();
    }
    if (this.selectedColumnId === 'out_attend') {
      this.attendForm.out_time = moment(this.selectedData.out_time).format('YYYY-MM-DDTHH:mm');
      this.attendForm.out_remarks = this.selectedData.out_remarks ? this.selectedData.out_remarks : '';
      this.attendForm.modified_by = this.username;
      this.outAttendModal.show();
    }
  }
  // selectedGrievance: any = {};
  selectedData: any = {};
  // updateComplainForm: any = {};
  methodFromParent(userData) {
    this.selectedData = userData;
    if (userData.action === 'image') {
      this.attachmentModal.show();
    }

    if (userData.action === 'edit') {
      this.attendForm.in_time = moment(this.selectedData.in_time).format('YYYY-MM-DDTHH:mm');
      this.attendForm.out_time = moment(this.selectedData.out_time).format('YYYY-MM-DDTHH:mm');
      this.attendForm.in_remarks = this.selectedData.in_remarks ? this.selectedData.in_remarks : '';
      this.attendForm.out_remarks = this.selectedData.out_remarks ? this.selectedData.out_remarks : '';
      this.attendForm.modified_by = this.username;
      this.updateComplaintModal.show();
    }
  }

  onBtnExport() {
    var params = this.getParams();
    if (params.suppressQuotes || params.columnSeparator) {
      alert(
        'NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel.'
      );
    }
    this.gridApi.exportDataAsCsv(params);
    setTimeout(() => {
      this.exportingCsv = false;
    }, 2000)
  }

  getParams() {

    let reportDate = "Complain List " + moment(this.filterParams.dateRange[0]).startOf('day').format('YYYY-MM-DD') + " to " + moment(this.filterParams.dateRange[1]).endOf('day').format('YYYY-MM-DD');
    return {
      suppressQuotes: '',
      columnSeparator: '',
      customHeader: reportDate,
      customFooter: '',
      fileName: 'Complain_List_' + moment(this.filterParams.dateRange[0]).format('YYYY-MM-DD') + "_to_" + moment(this.filterParams.dateRange[1]).endOf('day').format('YYYY-MM-DD')
    };
  }

  updateAttendance() {
    console.log(this.attendForm)
    let payload = {};
    payload['username'] = this.selectedData.username;
    payload['project'] = this.selectedData.project;
    payload['date'] = moment(this.selectedData.date).format('YYYY-MM-DD HH:mm:ss');
    if (this.attendForm.out_time) payload['out_time'] = this.attendForm.out_time;
    if (this.attendForm.in_time) payload['out_address'] = this.selectedData.out_location || this.selectedData.out_location !== '' ? this.selectedData.out_location : 'Office';
    if (this.attendForm.out_remarks) payload['out_remarks'] = this.attendForm.out_remarks;
    if (this.attendForm.modified_by) payload['modified_by'] = this.attendForm.modified_by;
    this.apiService.updateDetail('attendance', 'srl_no', this.selectedData.srl_no, payload).subscribe((response) => {
      this.searchReport();
      this.outAttendModal.hide();
    })
  }
  addAttendance() {
    console.log(this.attendForm)
    let payload = {};
    payload['username'] = this.selectedData.username;
    payload['project'] = this.selectedData.project;
    payload['date'] = moment(this.selectedData.date).format('YYYY-MM-DD HH:mm:ss');
    if (this.attendForm.in_time) payload['in_time'] = this.attendForm.in_time;
    if (this.attendForm.in_time) payload['in_address'] = this.selectedData.in_location || this.selectedData.in_location !== '' ? this.selectedData.in_location : 'Office';
    if (this.attendForm.in_remarks) payload['in_remarks'] = this.attendForm.in_remarks;
    if (this.attendForm.modified_by) payload['modified_by'] = this.attendForm.modified_by;
    if (this.selectedData?.srl_no) {
      this.apiService.updateDetail('attendance', 'srl_no', this.selectedData.srl_no, payload).subscribe((response) => {
        this.searchReport();
        this.inAttendModal.hide();
      })
    } else {
      this.apiService.addData('attendance', payload).subscribe((response) => {
        this.searchReport();
        this.inAttendModal.hide();
      })
    }

  }



  userList: any = [];
  projectList: any = [];
  projectObject: any = {};
  getResources() {
    let getUser = this.apiService.getData('employees');
    let getProject = this.apiService.getData('project');
    let that = this;
    Promise.all([getUser, getProject]).then((resp) => {
      that.userList = resp[0];
      that.projectUsers = resp[0];
      let u = that.constantService.arrangeMultiselectData(resp[0], 'phone_no', 'full_name');
      that.projectUsers = u;
      that.projectList = resp[1];
      _.each(that.projectList, (p) => {
        that.projectObject[p.srl_no] = p;
      })

      that.searchReport();
    })
  }

  punch_slot: any = [];
  projectUsers: any = [];
  selectProject(project) {
    console.log(project);
    let projectMatch = _.filter(this.projectList, { 'name': project });
    if (projectMatch.length > 0 && projectMatch[0].name) {
      let users = _.filter(this.userList, (user: any) => {
        return user.project === projectMatch[0].srl_no;
      })
      console.log(users);
      let u = this.constantService.arrangeMultiselectData(users, 'phone_no', 'full_name');
      this.projectUsers = u;
      console.log("this.projectUsers");
      console.log(this.projectUsers);
    }

  }


  exportPdf() {
    this.exportAsService.save(this.exportAsConfig, 'Complain_Report').subscribe(() => {

    });
  }


  excelExportData: any = [];

  ClickExport(): void {
    let complainDate = "";
    complainDate = "Daily Attendance Register  (" + moment(this.filterParams.date).format('YYYY-MM-DD') + ") - [ " + this.filterParams.attendance + " ]";

    let fileData = {
      fileName: "Attendance_Report_" + moment(this.filterParams.date).format('YYYY_MM_DD'),

      reportDate: moment().format('YYYY-MM-DD'),
      dateFilter: complainDate,
    }

    let header = ['Date', 'Project Name', 'Employee Id', 'Phone No', 'Full Name', 'Work Location', 'In Time', 'In GPS Location', 'In Location', 'View on map', 'In Image Link', 'In Image', 'Out TIme', 'Out GPS Location', 'Out Location', 'View On Map', 'Out Image Link', 'Out Image', 'Status'];
    this.excelService.generateExcel(this.excelExportData, fileData, header);
  }

  arrangeDataForExport(records) {
    let data: any = [];
    _.each(records, (r) => {
      let inLatLong = `${r.in_latitude},${r.in_longitude}`;
      let outLatLong = `${r.out_latitude},${r.out_latitude}`;
      let inMapLink = `https://www.google.com/maps/search/?api=1&query=${inLatLong}`;
      let outMapLink = `https://www.google.com/maps/search/?api=1&query=${outLatLong}`;
      data.push([r.date, r.project_name, r.employee_id, r.username, r.fullName, r.location, r.in_time, inLatLong, r.in_address, inMapLink, r.in_attachment, '=IMAGE()', r.out_time, outLatLong, r.out_location, outMapLink, r.out_attachment, '=IMAGE()', r.status]);
    });
    this.excelExportData = data;
  }

  onUserSelect(item: any) {
    console.log(item);
    const { item_id, item_text } = item;
    this.filterParams.username = item_id;
    console.log(this.filterParams);
  }

}
